import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Utils/AuthContext';
import { Center, Spinner } from '@chakra-ui/react';

interface ProtectedRouteProps {
    children: React.ReactElement;
    requiredRole?: 'User' | 'Supervisor' | 'Admin' | 'Basic User';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
    const { user, isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Show spinner while MSAL is initialising or role is being fetched
    if (isLoading) {
        return (
            <Center minH="100vh" bg="#FAFAF8">
                <Spinner size="lg" color="#0D1F4C" thickness="3px" />
            </Center>
        );
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // Role-based access logic
    if (requiredRole) {
        const isAdmin = user.role === 'Admin' || user.role === 'Supervisor';
        const isBasic = user.role === 'User' || user.role === 'Basic User';

        if (requiredRole === 'Supervisor' && !isAdmin) {
            return <Navigate to="/dashboard" replace />;
        }
        if (requiredRole === 'User' && !isBasic && !isAdmin) {
            return <Navigate to="/dashboard" replace />;
        }
        // Specific checks for new roles if needed
        if (user.role !== requiredRole && !isAdmin) {
             return <Navigate to="/dashboard" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
